module.exports = {
  help: 'Help',
  logout: 'Logout',
  chats: 'Chats',
  calls: 'Calls',
  cancel: 'Cancel',
  go: 'Go',
  modal_warning_text: 'Attention! When switching between modes you will go to the first page of the section. All unsaved changes on this page will be lost'
}
